<template>
  <div>
    <div class="ibox float-e-margins fadeInRight" v-if="this.recurringBookings && this.recurringBookings.length >0 &&  this.viewPage">
      <div class="ibox-title">
        <b>Repeated Bookings</b>
      </div>
      <div class="ibox-content" >
        <table class="table table-bordered white-bg">
          <tbody>
            <tr v-for="recurring in recurringBookings">
              <td><label><a :href="recurring.booking_url">{{ recurring.booking_num }}</a></label></td>
              <td><label>{{ recurring.booking_start_formatted }}</label></td>
              <td><label>{{ recurring.name }}</label></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
      <confirmation-popup
          title="Apply changes to related repeated bookings"
          message=" "
          id="repeated-booking-modal-new" :close-after-confirm="false"  :loading="true" cancel-btn-text="Close"  :show-confirm-btn="true" confirm-btn-text="Apply changes"  @on-confirm="submitRepeatBooking()">
          <repeat-bookings-modal :recurringBookings="this.recurringBookings" :workersNameSingular="workersNameSingular"></repeat-bookings-modal>
      </confirmation-popup>
  </div>
</template>
<script>
import {getRepeatingBookings} from "@/modules/Booking/api/repeatingBookings/";
import {EventBus} from "@/events/event-bus";
import ConfirmationPopup from "../../../common/components/ConfirmationPopup.vue";
export default {
  name: "repeatBookingsView",
    components: {ConfirmationPopup},
  props: {
    itemId: {
      default: null,
    },
    workersNameSingular: {
      default: 'fieldworker',
    },
    viewPage: {
          default() {
              return false;
          }
    },

  },
  data() {
    return {
       recurringBookings: null
    }
  },
  mounted() {
    this.getRepeatingBookingsList();
  },
  methods: {
    getRepeatingBookingsList(){
        getRepeatingBookings(this.itemId).then(response => {
            this.recurringBookings = response.data;
            if(this.recurringBookings){
                EventBus.$emit('ListenRepeatBookingData', this.recurringBookings);
                $("#is_repeated").val(true);
            }
        });
        EventBus.$on('viewModalRepeatBooking', id => {
            $(id).find("confirmButton").addClass("repeated_bookings_save");
            $(id).modal('show');
        })
    },
      submitRepeatBooking(){
          EventBus.$emit('dont_consider_availability',true);
          $('#service_deleted_flag').val(0);
          // $('.modal').modal('hide'); // closes all active pop ups.
          // $('.modal-backdrop').remove(); // removes the grey overlay.
          // $('#service_deleted_flag').val(0)
          // window.dont_consider_availability_flag = true;
         // save_booking();
      }
  }
}
</script>